import React from 'react'
import SewingRepairPage from './SewingRepairPage'
import '../styles/index.scss'

function SewingRepairContainer() {
    return (
        <div className='SewingRepairContainer'>
            <SewingRepairPage/>
        </div>
    )
}

export default SewingRepairContainer